import { useState } from 'react';

import { Modal, ModalDialogSlot, useModalDialog } from '@xemplo/modal-dialog';

import { AmendmentDetailsModalBody } from './modal/components/body/amendment-details-modal-body';
import { EditContentFactory } from './modal/components/edit-content-factory';
import { AmendmentDetailModalFooter } from './modal/components/footer/amendment-details-modal-footer';
import { ModalHeader as AmendmentDetailsModalHeader } from './modal/components/header/amendment-details-modal-header';

export const amendmentDetailsModalTestIds = {
  body: 'amendment-details-modal',
  footer: 'amendment-details-modal-footer',
  header: 'amendment-details-modal-header',
};

type AmendmentDetailsModalProps = {
  amendmentId: string;
  isOpen: boolean;
  dialogProps: ReturnType<typeof useModalDialog>['dialogProps'];
  onClose: () => void;
};

export function AmendmentDetailsModal({
  amendmentId,
  isOpen,
  dialogProps,
  onClose,
}: AmendmentDetailsModalProps) {
  const [isEditing, setIsEditing] = useState(false);

  const handleClose = () => {
    setIsEditing(false);
    onClose();
  };

  const handleEditOpen = () => setIsEditing(true);

  return (
    <Modal.Dialog {...dialogProps}>
      {isOpen && amendmentId && isEditing ? (
        <EditContentFactory amendmentId={amendmentId} onClose={handleClose} />
      ) : (
        <Modal>
          <Modal.Slot
            name={ModalDialogSlot.CloseButton}
            render={
              <Modal.CloseButton
                onClick={handleClose}
                id="amendment-details-modal-close-button"
                ariaLabel="Close amendment details modal"
              />
            }
          />
          <Modal.Slot
            name={ModalDialogSlot.Header}
            render={<AmendmentDetailsModalHeader amendmentId={amendmentId} />}
          />
          <Modal.Slot
            name={ModalDialogSlot.Body}
            render={
              <Modal.Body>
                <AmendmentDetailsModalBody amendmentId={amendmentId} />
              </Modal.Body>
            }
          />
          <Modal.Slot
            name={ModalDialogSlot.Footer}
            render={
              <AmendmentDetailModalFooter
                amendmentId={amendmentId}
                onClose={onClose}
                onEdit={handleEditOpen}
              />
            }
          />
        </Modal>
      )}
    </Modal.Dialog>
  );
}
